import { useContext, useRef, useEffect, useCallback } from "react";
import { has, unset, isFunction } from "lodash/fp";
import { useId } from "@reach/auto-id";
import "../contexts/display-mode-context/display-mode-context.es.js";
import "../contexts/global-edit-context/global-edit-context.es.js";
import { toastContext } from "../contexts/toast-context/toast-context.es.js";
function useToast(toasterId) {
  const { setToast, removeToast, toastMap } = useContext(toastContext);
  const hookId = useId();
  const counter = useRef(0);
  const dismissCallbacks = useRef({});
  const toasts = toastMap[toasterId];
  useEffect(() => {
    Object.keys(dismissCallbacks.current).forEach((toastId) => {
      if (!has(toastId, toasts)) {
        dismissCallbacks.current[toastId]();
        dismissCallbacks.current = unset(toastId, dismissCallbacks.current);
      }
    });
  }, [toasts]);
  return useCallback(
    (message, opts = {}) => {
      const { clickable = true, duration = 6e3, onDismiss, variant } = opts;
      counter.current += 1;
      const toastId = `toast-by-callback__${hookId}-${counter.current}`;
      const handleRemove = () => removeToast(toasterId, toastId);
      if (isFunction(onDismiss)) {
        dismissCallbacks.current[toastId] = onDismiss;
      }
      setToast(toasterId, toastId, {
        clickable,
        message,
        onDismiss: handleRemove,
        variant
      });
      setTimeout(handleRemove, duration);
    },
    [hookId, removeToast, setToast, toasterId]
  );
}
export {
  useToast
};
